import { ListTitle } from "@ui/ListTitle";
import { Text } from "@ui/typography/Text";
import { createResource, For, Show } from "solid-js";
import { listDiscoverySuggestedInfluencers } from "@/client";
import { CreatorCategoryCard } from "./CreatorCategoryCard";

export const SuggestedCreators = () => {
	const [creators] = createResource(async () => {
		const res = await listDiscoverySuggestedInfluencers();
		return res.data?.influencers ?? [];
	});

	return (
		<section>
			<div class="askgvt-section-head">
				<ListTitle>Suggested for you</ListTitle>
			</div>
			<Show
				when={!creators.loading}
				fallback={
					<Text size="small" color="fg3">
						Loading creators…
					</Text>
				}
			>
				<Show
					when={(creators()?.length ?? 0) > 0}
					fallback={
						<Text size="small" color="fg3">
							No creators to show yet.
						</Text>
					}
				>
					<div class="askgvt-creators askgvt-creators--shelf">
						<For each={creators() ?? []}>
							{(creator) => <CreatorCategoryCard creator={creator} />}
						</For>
					</div>
				</Show>
			</Show>
		</section>
	);
};
